<template>
  <div class="content">
    <div class="box">
      <div
        @click="open(item)"
        class="box-card"
        v-for="(item, index) in array"
        :key="index"
      >
        <div class="text item" :style="{ background: item.backgroundColor }">
          <img class="icon" :src="item.icon" alt="" /> {{ item.name }}
        </div>
      </div>
    </div>
    <div v-if="drawer" class="info">
      <el-page-header @back="close" :content="title"> </el-page-header>
      <!-- 综合态势 -->
      <zhts v-if="type == 'zhts'"></zhts>
      <!-- 智慧运营 -->
      <zhyy v-if="type == 'zhyy'"></zhyy>
      <!-- 智慧经营 -->
      <zhjy v-if="type == 'zhjy'"></zhjy>
      <!-- 智慧物业 -->
      <zhwy v-if="type == 'zhwy'"></zhwy>
      <!-- 园区党建 -->
      <yqdj v-if="type == 'yqdj'"></yqdj>
      <!-- 数智管理 -->
      <szgl v-if="type == 'szgl'"></szgl>
    </div>
  </div>
</template>

<script>
import zhts from "./components/zhts.vue";
import zhyy from "./components/zhyy.vue";
import zhjy from "./components/zhjy.vue";
import zhwy from "./components/zhwy.vue";
import yqdj from "./components/yqdj.vue";
import szgl from "./components/szgl.vue";
export default {
  components: { yqdj, zhjy, zhts, zhwy, zhyy,szgl },
  data() {
    return {
      array: [
        {
          name: "综合态势",
          type: "zhts",
          backgroundColor: `linear-gradient(105deg, #25C4FF 0%, #1092FE 100%)`,

          icon: require("../../../static/zhts.png"),
        },
        {
          name: "智慧运营",
          type: "zhyy",
          backgroundColor: `linear-gradient(105deg, #FF8422 0%, #FFB45C 100%)`,
          icon: require("../../../static/zhyy.png"),
        },
        {
          name: "智慧经营",
          type: "zhjy",
          backgroundColor: `linear-gradient(105deg, #1AB8DE 0%, #23EBB1 100%)`,
          icon: require("../../../static/zhjy.png"),
        },
        {
          name: "数智管理",
          type: "szgl",
          backgroundColor: `linear-gradient(105deg, #C96CF5 0%, #9246F8 100%)`,
          icon: require("../../../static/zhwy.png"),
        },
        {
          name: "园区党建",
          type: "yqdj",
          backgroundColor: `linear-gradient(105deg, #FF3C3C 0%, #FF8978 100%)`,
          icon: require("../../../static/yqdj.png"),
        },
      ],
      drawer: false,
      direction: "rtl",
      title: "详情页面",
      type: "",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    open(item) {
      this.title = item.name;
      this.type = item.type;
      this.drawer = true;
    },
    close() {
      this.drawer = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
}
.info {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px;
}

.box-card {
  width: 300px;
  height: 100px;
  display: inline-block;
  margin: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #fff;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  text-align: center;
  line-height: 100px;
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon {
    width: 20px;
    height: 20px;
    margin-right: 13px;
  }
}
</style>
